var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98941 3C5.34817 3 2.71173 4.52834 0.678395 7.44298L0.676935 7.44509C0.564651 7.60781 0.503119 7.80016 0.500115 7.99784C0.497119 8.19503 0.552495 8.38869 0.659261 8.55448C2.23054 11.0135 4.8342 13 7.98941 13C11.1114 13 13.7662 11.0094 15.3414 8.54315C15.4453 8.38125 15.5006 8.19289 15.5006 8.00047C15.5006 7.8077 15.4451 7.619 15.3408 7.4569L15.34 7.45575C13.7635 5.02086 11.0914 3 7.98941 3ZM1.50139 8.0152L1.5 8.01304C3.40017 5.29037 5.75997 4 7.98941 4C10.6457 4 13.0414 5.7461 14.5 7.9982L14.5005 7.99943L14.5006 8.00047L14.4999 8.00284L14.4989 8.00433C13.0459 10.2797 10.6697 12 7.98941 12C5.27876 12 2.95267 10.287 1.50139 8.0152ZM6.00003 8C6.00003 6.89543 6.89546 6 8.00003 6C9.1046 6 10 6.89543 10 8C10 9.10457 9.1046 10 8.00003 10C6.89546 10 6.00003 9.10457 6.00003 8ZM8.00003 5C6.34318 5 5.00003 6.34315 5.00003 8C5.00003 9.65685 6.34318 11 8.00003 11C9.65689 11 11 9.65685 11 8C11 6.34315 9.65689 5 8.00003 5Z",
    fill: "#777E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.86f5d23b55afcdaca18ad30c728ceb46.svg";
export { ForwardRef as ReactComponent };